import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { db } from '../../lib/supabase'

export default function EventsApi() {
  const navigate = useNavigate()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: eventos } = await db.getEventos()
        
        const events = eventos?.filter(e => e.publicado).map(evento => ({
          "@type": "Event",
          id: evento.id,
          name: evento.nombre,
          description: evento.descripcion || `Evento ${evento.nombre} en Plaza Aurora Outlet`,
          category: evento.categorias?.nombre || null,
          url: `https://www.plazaaurora.pe/eventos/${evento.id}`,
          image: evento.imagen_url || null,
          startDate: evento.fecha_inicio || null,
          endDate: evento.fecha_fin || evento.fecha_inicio || null,
          status: evento.estado || "Activo",
          eventStatus: evento.estado === 'Activo' ? 'https://schema.org/EventScheduled' : evento.estado === 'Finalizado' ? 'https://schema.org/EventCancelled' : 'https://schema.org/EventScheduled',
          eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
          location: {
            "@type": "Place",
            name: "Plaza Aurora Outlet",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Av. Carlos Izaguirre 271-275",
              addressLocality: "Independencia",
              addressRegion: "Lima",
              addressCountry: "PE"
            }
          },
          organizer: {
            "@type": "Organization",
            name: "Plaza Aurora Outlet",
            url: "https://www.plazaaurora.pe"
          },
          isAccessibleForFree: evento.is_free !== false,
          offers: evento.price && evento.price > 0 ? {
            "@type": "Offer",
            price: evento.price,
            priceCurrency: evento.currency || "PEN",
            availability: evento.availability ? `https://schema.org/${evento.availability}` : "https://schema.org/InStock",
            url: `https://www.plazaaurora.pe/eventos/${evento.id}`
          } : null,
          performer: evento.performer || null,
          seo: {
            title: evento.seo_title || null,
            description: evento.seo_description || null,
            ogImage: evento.og_image_url || null
          }
        })) || []

        const response = {
          "@context": "https://schema.org",
          "@type": "ItemList",
          name: "Eventos en Plaza Aurora Outlet",
          description: "Listado de todos los eventos, promociones y actividades en Plaza Aurora, el mejor outlet de Lima Norte",
          numberOfItems: events.length,
          itemListElement: events.map((event, index) => ({
            "@type": "ListItem",
            position: index + 1,
            item: event
          }))
        }

        // Return as JSON
        const blob = new Blob([JSON.stringify(response, null, 2)], { type: 'application/json' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'events.json'
        link.click()
        URL.revokeObjectURL(url)
        
        // Redirect after download
        setTimeout(() => navigate('/eventos'), 1000)
      } catch (error) {
        console.error('Error generating events.json:', error)
        navigate('/eventos')
      }
    }

    fetchData()
  }, [navigate])

  return (
    <div style={{ 
      maxWidth: '600px', 
      margin: '4rem auto', 
      padding: '2rem',
      textAlign: 'center'
    }}>
      <h1 style={{ fontFamily: 'var(--font-display)', marginBottom: '1rem' }}>
        Generando events.json...
      </h1>
      <p style={{ color: 'var(--color-text-muted)' }}>
        Tu descarga comenzará en un momento.
      </p>
    </div>
  )
}
